import { Component, input } from '@angular/core';
import type { MissionStatusCode } from '@killer-party/contracts';
import { twoDigits } from '../../domain/format';
import { missionStatusLabel } from '../../domain/labels';
import { missionBadge } from '../badges';

export interface RankingRow {
  rank: number;
  firstName: string;
  codeName: string;
  statusCode: MissionStatusCode;
  score: number;
  eliminatedBy?: string | null;
}

// Classement : statut de chaque agent (page publique) ou son chasseur (rapport final).
@Component({
  selector: 'app-ranking-table',
  templateUrl: './ranking-table.html',
})
export class RankingTable {
  readonly rows = input.required<RankingRow[]>();
  readonly lastColumn = input<'status' | 'eliminatedBy'>('status');
  readonly selfCodeName = input<string | null>(null);

  protected readonly digits = twoDigits;

  protected isOut(row: RankingRow): boolean {
    return row.statusCode === 'FAILED' || row.statusCode === 'ABORTED';
  }

  protected label(row: RankingRow): string {
    return missionStatusLabel(row.statusCode);
  }

  protected readonly badge = missionBadge;
}
